export default __webpack_public_path__ + "static/media/D6R.eae2671a.pdf";